module.exports = __webpack_public_path__ + "img/banner01.d9792f5d.png";